import React, { useContext, useEffect, useRef, useState } from 'react';
import MsgUtils from '../Tools/MsgUtils';
import { ContextGloball } from '../Context/ContextGlobal';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import Modal from 'react-bootstrap/Modal';
import { ReactSession } from "react-client-session";

const server = process.env.REACT_APP_SERVER;

function PedidoPapa() {

    const { setLoading } = useContext(ContextGloball);

    const tableRef = useRef();

    const [fecha, setFecha] = useState(new Date().toISOString().split('T')[0]);

    const [proveedores, setProveedores] = useState([]);
    const [proveedor, setProveedor] = useState('');
    const [presentacion, setPresentacion] = useState(15);
    const [tipoPapa, setTipoPapa] = useState('7 mm');
    const [precio, setPrecio] = useState(22.50);

    const [showModal, setShowModal] = useState(false);

    const infoUser = JSON.parse(localStorage.getItem('info'));

    const [fechaBaseAux, setFechaBaseAux] = useState('');

    const [listaSucursal, setListaSucursal] = useState([]);

    const [validado, setValidado] = useState(false);

    async function obtenerPedidoGuardado(datos, fechaHoy) {

    try {

        const response = await fetch(
            `${server}/almacen/obtenerSolicitudDePedido`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional: infoUser.ID_REGIONAL_ACTUAL,
                    fecha: fechaHoy
                })
            }
        );

        const data = await response.json();

        if (!data.success) {
            MsgUtils.msgError(data.mensaje);
            return datos;
        }


        // NO EXISTE PEDIDO
        if (!data.existe) {

            // No existe pedido, todavía se puede validar
            setValidado(false);

            return datos;
        }

        // Ya existe pedido guardado
        setValidado(true);

        const cabecera = data.pedido[0];

        setProveedor(
            Number(cabecera.ID_PROVEEDOR || '')
        );

        setPresentacion(
            Number(cabecera.PRESENTACION || 0)
        );

        setTipoPapa(
            cabecera.TIPO_PAPA || ''
        );

        setPrecio(
            Number(cabecera.PRECIO || 0)
        );

        // EXISTE PEDIDO
        return datos.map(item => {

            const guardado = data.pedido.find(
                p => Number(p.ID_SUCURSAL) ===
                     Number(item.ID_SUCURSAL)
            );

            if (!guardado) {
                return item;
            }

            return {
                ...item,

                ID_PEDIDO: guardado.ID_PEDIDO,

                SOLICITUD:
                    Number(guardado.SOLICITUD || 0),

                PRIMERA_VUELTA:
                    Number(guardado.PRIMERA_VUELTA || 0),

                SEGUNDA_VUELTA:
                    Number(guardado.SEGUNDA_VUELTA || 0)
            };

        });

    } catch (error) {

        console.error(
            'Error obteniendo pedido guardado:',
            error
        );

        return datos;
    }
}

    async function obtenerProveedoresPapa() {

        try {
            const response = await fetch(
                `${server}/almacen/obtenerProveedoresPapa`,
                {
                    method: 'POST',

                    headers: {
                        'Content-Type': 'application/json'
                    },

                    body: JSON.stringify({
                        regional: infoUser.ID_REGIONAL_ACTUAL
                    })
                }
            );
            const data = await response.json();
            if (!data.success) {
                MsgUtils.msgError(
                    data.mensaje || 'Error al obtener proveedores'
                );
                return;
            }
            setProveedores(data.proveedores);
            // Seleccionar automáticamente el primero
            if (data.proveedores.length > 0) {
                setProveedor(
                    data.proveedores[4].ID_PROVEEDOR
                );
            }

        } catch (error) {

            console.error(
                'Error al obtener proveedores:',
                error
            );

            MsgUtils.msgError(
                'No se pudieron obtener los proveedores'
            );

        } finally {

            setLoading(false);
        }
    }

    /*
    async function obtenerDatos() {
            const [anio, mes, dia] = fecha.split('-');
            const fechaHoy = `${dia}/${mes}/${anio}`;

            fetch(`${server}/reporte/getproyeccionPolloDiario`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    fechaIni: fechaHoy,
                    fechaFin: fechaHoy,
                    regional: infoUser.ID_REGIONAL_ACTUAL
                })
            })
                .then(res => res.json())
                .then(async data => {
                    if (data.error) {
                        MsgUtils.msgError(data.error);
                    } else {

                        const datos = data.ok.rows.map(item => {

                            const solicitud = obtenerSolicitud(item);

                            return {
                                ...item,
                                SOLICITUD: solicitud,
                                PRIMERA_VUELTA: solicitud,
                                SEGUNDA_VUELTA: 0
                            };
                        });

                        const datosFinales = await obtenerPedidoGuardado(
                            datos,
                            fechaHoy
                        );

                        setListaSucursal(datosFinales);
                    }
                })
                .catch(error => MsgUtils.msgError(error));
        }*/

    async function obtenerDatos() {

    try {

        const [anio, mes, dia] = fecha.split('-');

        // Fecha para la cual estamos haciendo el pedido
        // Ejemplo: 08/10/2026
        const fechaPedido =
            `${dia}/${mes}/${anio}`;

        // Día en el que se prepara el pedido
        // Ejemplo: 07/10/2026
        const fechaBase =
            obtenerFechaAnterior(fecha);

        setFechaBaseAux(fechaBase);

        console.log('=============================');
        console.log('FECHA BASE:', fechaBase);
        console.log('FECHA PEDIDO:', fechaPedido);
        console.log('=============================');

        setLoading(true);


            // =========================================================
            // 1. OBTENER DATOS DEL DÍA ANTERIOR
            //    Necesitamos:
            //    - SALDO
            //    - PROYECCIÓN
            // =========================================================

            const responseAyer = await fetch(
                `${server}/reporte/getproyeccionPolloDiario`,
                {
                    method: 'POST',

                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },

                    body: JSON.stringify({
                    fechaIni: fechaBase,
                    fechaFin: fechaBase,
                    regional: infoUser.ID_REGIONAL_ACTUAL
                })
                }
            );


            const dataAyer =
                await responseAyer.json();


            if (dataAyer.error) {

                MsgUtils.msgError(dataAyer.error);

                return;
            }



            // =========================================================
            // 2. OBTENER PROYECCIÓN DE HOY
            // =========================================================

            const responseHoy = await fetch(
                `${server}/reporte/getproyeccionPolloDiario`,
                {
                    method: 'POST',

                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },

                    body: JSON.stringify({
                    fechaIni: fechaPedido,
                    fechaFin: fechaPedido,
                    regional: infoUser.ID_REGIONAL_ACTUAL
                })
                }
            );


            const dataHoy =
                await responseHoy.json();


            if (dataHoy.error) {

                MsgUtils.msgError(dataHoy.error);

                return;
            }



            // =========================================================
            // 3. OBTENER SOLICITUD GUARDADA DEL DÍA ANTERIOR
            //
            // Esa solicitud es LO QUE LLEGA HOY
            // =========================================================

            const responsePedidoAyer = await fetch(
                `${server}/almacen/obtenerSolicitudDePedido`,
                {
                    method: 'POST',

                    headers: {
                        'Content-Type': 'application/json'
                    },

                    body: JSON.stringify({
                        regional:
                            infoUser.ID_REGIONAL_ACTUAL,

                        fecha:
                             fechaBase  // anterior
                    })
                }
            );


            const pedidoAyer =
                await responsePedidoAyer.json();



            console.log(
                'PEDIDO DÍA ANTERIOR:',
                pedidoAyer
            );



            // =========================================================
            // 4. RECORRER LAS SUCURSALES DEL DÍA ACTUAL
            // =========================================================

            const datos = (dataAyer.ok?.rows || []).map(
                itemAyer => {


                    // =============================================
                    // BUSCAR PROYECCIÓN DE HOY
                    // =============================================

                    const itemHoy =
                        (dataHoy.ok?.rows || []).find(
                            item =>
                                Number(item.ID_SUCURSAL) ===
                                Number(itemAyer.ID_SUCURSAL)
                        );


                    // =============================================
                    // BUSCAR SOLICITUD DE AYER
                    // =============================================

                    const pedidoGuardadoAyer =
                        (pedidoAyer.pedido || []).find(
                            item =>
                                Number(item.ID_SUCURSAL) ===
                                Number(itemAyer.ID_SUCURSAL)
                        );


                    const solicitudAyer =
                        Number(
                            pedidoGuardadoAyer?.SOLICITUD || 0
                        );


                    // =============================================
                    // CALCULAR SOLICITUD DE HOY
                    // =============================================

                    const solicitud =
                        obtenerSolicitud(
                            itemAyer,
                            itemHoy,
                            solicitudAyer
                        );


                    return {
                        ...itemAyer,

                        // Para revisar el cálculo
                        PROYECCION_BASE:
                            Number(itemAyer?.CANTIDAD || 0),

                        // Proyección correspondiente a la fecha seleccionada
                        PROYECCION_PEDIDO:
                            Number(itemHoy?.CANTIDAD || 0),

                        SOLICITUD_AYER:
                            solicitudAyer,

                        SOLICITUD:
                            solicitud,

                        PRIMERA_VUELTA:
                            solicitud,

                        SEGUNDA_VUELTA:
                            0
                    };
                }
            );



            // =========================================================
            // 5. SI EL PEDIDO DE HOY YA ESTÁ GUARDADO,
            //    MOSTRAR LOS VALORES GUARDADOS
            // =========================================================

            const datosFinales =
                await obtenerPedidoGuardado(
                    datos,
                    fechaPedido
                );


            setListaSucursal(
                datosFinales
            );


        } catch (error) {

            console.error(
                'Error obteniendo datos:',
                error
            );


            MsgUtils.msgError(
                'Error obteniendo los datos'
            );


        } finally {

            setLoading(false);
        }
    }

    // =========================================================
    // MODIFICAR VALORES DE LA TABLA
    // =========================================================

    function cambiarValor(index, campo, valor) {

        const nuevaLista = [...listaSucursal];

        const nuevoValor =
            valor === '' ? '' : Number(valor);

        nuevaLista[index] = {
            ...nuevaLista[index],
            [campo]: nuevoValor
        };

        // Si modificamos SOLICITUD,
        // la 1RA VUELTA también toma ese valor
        if (campo === 'SOLICITUD') {
            nuevaLista[index].PRIMERA_VUELTA = nuevoValor;
        }

        setListaSucursal(nuevaLista);

        if (
            campo === 'SOLICITUD' ||
            campo === 'PRIMERA_VUELTA' ||
            campo === 'SEGUNDA_VUELTA'
        ) {
            setValidado(false);
        }
    }


    // =========================================================
    // TOTALES
    // =========================================================

    function getTotal(campo) {

        return listaSucursal.reduce(
            (total, item) => total + Number(item[campo] || 0),
            0
        );
    }


    // =========================================================
    // VALIDAR
    // =========================================================

    async function validarPedido() {

        if (fecha === '') {
            MsgUtils.msgError('Seleccione una fecha');
            return;
        }

        if (listaSucursal.length === 0) {
            MsgUtils.msgError('No existen sucursales');
            return;
        }

         try {
            const response = await fetch(
                `${server}/almacen/guardarSolicitudDePedido`,
                {
                    method: 'POST',

                    headers: {
                        'Content-Type': 'application/json'
                    },

                    body: JSON.stringify({
                            regional: infoUser.ID_REGIONAL_ACTUAL,
                            usuario: ReactSession.get("idSession"),
                            fecha: fecha,

                            proveedor: proveedor,
                            presentacion: presentacion,
                            tipoPapa: tipoPapa,
                            precio: precio,

                            pedidoSolicitado: listaSucursal
                })
                }
            );
            const data = await response.json();
            if (!data.success) {
                
                return alert('Error al guardar solicitud de pedido');
            }
            setValidado(true);
            
            MsgUtils.msgInfo
                ? MsgUtils.msgInfo('Datos validados correctamente')
                : console.log('Datos validados correctamente');
        } catch (error) {
                console.error('Error al guardar solicitud de pedidos:', error);

                MsgUtils.msgError(
                    'No se pudo guardar la solicitud de pedido'
                );
            } finally {

            setLoading(false);
        }

        
    }


    // =========================================================
    // GENERAR
    // =========================================================

    function generarPedido() {

        if (fecha === '') {
            MsgUtils.msgError('Seleccione una fecha');
            return;
        }

        /*
            Más adelante aquí realizaremos
            la fórmula exacta del Excel.
        */

        setShowModal(true);
    }


    // =========================================================
    // OBTENER DÍA DE LA SEMANA
    // =========================================================

    function getDiaSemana() {

        if (fecha === '') {
            return '';
        }

        /*
            T00:00:00 evita algunos problemas
            de interpretación de fecha.
        */

        const fechaSeleccionada = new Date(
            `${fecha}T00:00:00`
        );

        return fechaSeleccionada
            .toLocaleDateString('es-ES', {
                weekday: 'long'
            })
            .toUpperCase();
    }

    /*function obtenerSolicitud(item) {

        if ((item.SUCURSAL === 'Quillacollo' || item.SUCURSAL === 'Sacaba') && item.SALDO_EN_CAJAS < 2) {
            return 2;
        }

        if (item.SUCURSAL === 'Hupermall' && item.SALDO_EN_CAJAS < 2) {
            return 5;
        }

        if (item.SUCURSAL === 'Despachos 2' && item.SALDO_EN_CAJAS < 2) {
            return 10;
        }

        if(item.SALDO_EN_CAJAS >= item.CANTIDAD){
             return 0;
        }
        else{
            return item.CANTIDAD - item.SALDO_EN_CAJAS;
        }
    }*/

    function obtenerSolicitud(itemHoy, itemManana, solicitudAyer) {

        const saldoHoy =
            Number(itemHoy?.SALDO_EN_CAJAS || 0);

        const proyeccionHoy =
            Number(itemHoy?.CANTIDAD || 0);

        const llegadaHoy =
            Number(solicitudAyer || 0);

        const proyeccionManana =
            Number(itemManana?.CANTIDAD || 0);

        const sobrante =
            saldoHoy +
            llegadaHoy -
            proyeccionHoy;

        const solicitud =
            proyeccionManana -
            sobrante;

        return Math.max(
            0,
            Math.trunc(solicitud)
        );
    }

    function obtenerFechaAnterior(fechaActual) {

        const [anio, mes, dia] = fechaActual.split('-');

        const fechaObj = new Date(
            Number(anio),
            Number(mes) - 1,
            Number(dia)
        );

        fechaObj.setDate(fechaObj.getDate() - 1);

        const d = String(fechaObj.getDate()).padStart(2, '0');
        const m = String(fechaObj.getMonth() + 1).padStart(2, '0');
        const a = fechaObj.getFullYear();

        return `${d}/${m}/${a}`;
    }

    function obtenerFechaSiguiente(fechaActual) {

        const [anio, mes, dia] = fechaActual.split('-');

        const fechaObj = new Date(
            Number(anio),
            Number(mes) - 1,
            Number(dia)
        );

        fechaObj.setDate(fechaObj.getDate() + 1);

        const d = String(fechaObj.getDate()).padStart(2, '0');
        const m = String(fechaObj.getMonth() + 1).padStart(2, '0');
        const a = fechaObj.getFullYear();

        return `${d}/${m}/${a}`;
    }

    useEffect(() => {
        obtenerProveedoresPapa();
        obtenerDatos();
    }, [fecha]);




    return (
        <>

            {/* =====================================================
                CABECERA
            ====================================================== */}

            <div className='container-fluid bg-dark bg-gradient py-2'>

                <div className='row gx-1 g-1 align-items-center'>

                    {/* FECHA */}

                    <div
                        className='col'
                        style={{
                            minWidth: '190px',
                            maxWidth: '190px'
                        }}
                    >

                        <div className="input-group input-group-sm">

                            <span
                                className="input-group-text bg-transparent text-light"
                                style={{ border: 'none' }}
                            >
                                Fecha
                            </span>

                            <input
                                type="date"
                                className="form-control"
                                value={fecha}
                                onChange={(e) =>
                                    setFecha(e.target.value)
                                }
                            />

                        </div>

                    </div>


                    {/* VALIDAR */}

                    <div
                        className='col'
                        style={{
                            minWidth: '100px',
                            maxWidth: '100px'
                        }}
                    >

                        <button
                            className='btn btn-sm btn-secondary w-100'
                            onClick={validarPedido}
                            disabled={validado}
                            title={
                                validado
                                    ? 'El pedido ya está validado'
                                    : 'Validar pedido'
                            }
                        >
                            <i className="fa-solid fa-check"></i>
                            {' '}
                            {validado ? 'Validado' : 'Validar'}
                        </button>

                    </div>


                    {/* GENERAR */}

                    <div
                        className='col'
                        style={{
                            minWidth: '100px',
                            maxWidth: '100px'
                        }}
                    >

                        <button
                            className='btn btn-sm btn-primary w-100'
                            onClick={generarPedido}
                        >
                            <i className="fa-solid fa-gears"></i>
                            {' '}Generar
                        </button>

                    </div>


                    {/* EXCEL */}

                    <div
                        className='col'
                        style={{
                            minWidth: '100px',
                            maxWidth: '100px'
                        }}
                    >

                        <DownloadTableExcel
                            filename={`PedidoPapa_${fecha}`}
                            sheet="Pedido Papa"
                            currentTableRef={tableRef.current}
                        >

                            <button
                                className='btn btn-sm btn-success w-100'
                            >
                                <i className="fa-solid fa-file-excel"></i>
                                {' '}Excel
                            </button>

                        </DownloadTableExcel>

                    </div>

                </div>

            </div>


            {/* =====================================================
                INFORMACIÓN DEL PRODUCTO
            ====================================================== */}

            <div className='container-fluid bg-secondary py-2'>

                <div className='row row-cols-auto gx-2 g-2 justify-content-center'>

                    <div className='col'>

                        <div className="input-group input-group-sm">

                            <span className="input-group-text">
                                Proveedor
                            </span>

                            <select
                                className="form-select form-select-sm"
                                value={proveedor}
                                disabled = {true}
                                onChange={(e) =>
                                    setProveedor(Number(e.target.value))
                                }
                            >
                                <option value="">
                                    Seleccione...
                                </option>

                                {proveedores.map((item) => (

                                    <option
                                        key={item.ID_PROVEEDOR}
                                        value={item.ID_PROVEEDOR}
                                    >
                                        {item.NOMBRE}
                                    </option>

                                ))}

                            </select>

                        </div>

                    </div>


                    <div className='col'>

                        <div className="input-group input-group-sm">

                            <span className="input-group-text">
                                Presentación
                            </span>

                            <input
                                type="number"
                                className="form-control text-center"
                                style={{ width: '70px' }}
                                value={presentacion}
                                onChange={(e) => {
                                    setPresentacion(e.target.value);
                                    setValidado(false);
                                }}
                            />

                            <span className="input-group-text">
                                Kg
                            </span>

                        </div>

                    </div>


                    <div className='col'>

                        <div className="input-group input-group-sm">

                            <span className="input-group-text">
                                Papa
                            </span>

                            <input
                                type="text"
                                className="form-control text-center"
                                style={{ width: '70px' }}
                                value={tipoPapa}
                                onChange={(e) => {
                                    setTipoPapa(e.target.value);
                                    setValidado(false);
                                }}
                            />

                        </div>

                    </div>


                    <div className='col'>

                        <div className="input-group input-group-sm">

                            <span className="input-group-text">
                                Precio
                            </span>

                            <input
                                type="number"
                                step="0.01"
                                className="form-control text-center"
                                style={{ width: '80px' }}
                                value={precio}
                                onChange={(e) => {
                                    setPrecio(e.target.value);
                                    setValidado(false);
                                }}
                            
                            />

                            <span className="input-group-text">
                                Bs/Kg
                            </span>

                        </div>

                    </div>

                </div>

            </div>


            {/* =====================================================
                TABLA DE TRABAJO
            ====================================================== */}

          <div className='table-responsive'>

                <table
                    className="table table-dark table-sm table-striped table-hover mb-0"
                    ref={tableRef}
                    style={{
                        width: '100%',
                        tableLayout: 'fixed'
                    }}
                >

                    <colgroup>
                        <col style={{ width: '4%' }} />   {/* # */}
                        <col style={{ width: '10%' }} />  {/* SUCURSAL */}
                        <col style={{ width: '12%' }} />  {/* SALDO */}
                        <col style={{ width: '14%' }} />  {/* PROYECCION */}
                        <col style={{ width: '16%' }} />  {/* SOLICITUD */}
                        <col style={{ width: '16%' }} />  {/* 1RA VUELTA */}
                        <col style={{ width: '16%' }} />  {/* 2DA VUELTA */}
                    </colgroup>

                    <thead className='text-center align-middle'>
                        <tr>
                            <th>#</th>
                            <th>SUCURSAL</th>
                            <th>SALDO EN CAJAS <br />{fechaBaseAux}</th>
                            <th>PROYECCIÓN POLLO</th>
                            <th>SOLICITUD</th>
                            <th>1RA VUELTA</th>
                            <th>2DA VUELTA</th>
                        </tr>
                    </thead>


                    <tbody className='text-center'>

                        {listaSucursal.map((item, index) => {

                            return (

                                <tr key={item.ID_SUCURSAL}>

                                    <td className='text-center'>
                                        {index + 1}
                                    </td>


                                    <td className='text-center'>
                                        {item.SUCURSAL}
                                    </td>


                                    {/* SALDO */}
                                    <td className='text-center'>
                                        {Number(item.SALDO_EN_CAJAS || 0).toFixed(0)}
                                    </td>

                                    {/* PROYECCION */}
                                    <td className='fw-bold align-middle text-center'>
                                        {Number(item.PROYECCION_PEDIDO || 0).toFixed(0)}
                                    </td>

                                    {/* SOLICITUD */}
                                    {/*
                                    <td className='fw-bold align-middle text-center'>
                                            {Number(item.SOLICITUD || 0).toFixed(0)}
                                    </td>*/}
                                    
                                    <td>
                                       
                                        
                                        <input
                                            type="number"
                                            className="form-control form-control-sm text-center mx-auto"
                                            style={{ width: '50%' }}
                                            value={item.SOLICITUD ?? ''}
                                            onChange={(e) =>
                                                cambiarValor(index, 'SOLICITUD', e.target.value)
                                            }
                                        />
                                    <span style={{ display: 'none' }}>
                                        {item.SOLICITUD}
                                    </span>
                                    </td>

                                    {/* PRIMERA VUELTA */}

                                    <td>

                                       <input
                                            type="number"
                                            className="form-control form-control-sm text-center mx-auto"
                                            style={{ width: '50%' }}
                                            value={item.PRIMERA_VUELTA ?? ''}
                                            onChange={(e) =>
                                                cambiarValor(index, 'PRIMERA_VUELTA', e.target.value)
                                            }
                                        />
                                    <span style={{ display: 'none' }}>
                                        {item.PRIMERA_VUELTA}
                                    </span>
                                    </td>

                                    {/* SEGUNDA VUELTA */}

                                    <td>

                                        <input
                                            type="number"
                                            className="form-control form-control-sm text-center mx-auto"
                                            style={{ width: '50%' }}
                                            value={item.SEGUNDA_VUELTA ?? ''}
                                            onChange={(e) =>
                                                cambiarValor(index, 'SEGUNDA_VUELTA', e.target.value)
                                            }
                                        />
                                        <span style={{ display: 'none' }}>
                                                {item.SEGUNDA_VUELTA}
                                        </span>
                                    </td>
                                   
                                </tr>

                            );

                        })}

                    </tbody>


                    {/* =================================================
                        TOTALES
                    ================================================== */}

                    <tfoot className='text-center fw-bold'>

                        <tr>

                            <td></td>

                            <td>
                                TOTAL
                            </td>

                            <td>
                                {getTotal('SALDO_EN_CAJAS')}
                            </td>

                            <td>
                                {getTotal('PROYECCION_PEDIDO')}
                            </td>

                            <td>
                                {getTotal('SOLICITUD')}
                            </td>

                            <td>
                                {getTotal('PRIMERA_VUELTA')}
                            </td>

                            <td>
                                {getTotal('SEGUNDA_VUELTA')}
                            </td>

                        </tr>

                    </tfoot>

                </table>

            </div>


            {/* =====================================================
                MODAL PEDIDO GENERADO
            ====================================================== */}

            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark bg-gradient'
            >

                <Modal.Header
                    closeButton
                    closeVariant='white'
                    bsPrefix='modal-header m-0 p-0 px-2'
                >

                    <Modal.Title>

                        <div className='text-light'>
                            Pedido de Papa
                        </div>

                    </Modal.Title>

                </Modal.Header>


                <Modal.Body>

                    {/* INFORMACIÓN */}

                    <div className='text-light mb-3'>

                        <div className='row'>

                            <div className='col-md-4'>
                                <strong>Fecha:</strong>
                                {' '}
                                {fecha}
                            </div>

                            <div className='col-md-4'>
                                <strong>Día:</strong>
                                {' '}
                                {getDiaSemana()}
                            </div>

                            <div className='col-md-4'>
                                <strong>Proveedor:</strong>
                                {' '}
                                {proveedor}
                            </div>

                        </div>


                        <div className='row mt-2'>

                            <div className='col-md-4'>
                                <strong>Presentación:</strong>
                                {' '}
                                {presentacion} Kg
                            </div>

                            <div className='col-md-4'>
                                <strong>Papa:</strong>
                                {' '}
                                {tipoPapa}
                            </div>

                            <div className='col-md-4'>
                                <strong>Precio:</strong>
                                {' '}
                                {Number(precio || 0).toFixed(2)} Bs/Kg
                            </div>

                        </div>

                    </div>


                    {/* TABLA PEDIDO */}

                    <div className='table-responsive'>

                        <table className="table table-dark table-sm table-striped table-hover">

                            <thead className='text-center'>

                                <tr>

                                    <th>
                                        N°
                                    </th>

                                    <th>
                                        SUCURSAL
                                    </th>

                                    <th>
                                        DIRECCIÓN
                                    </th>

                                    <th>
                                        {getDiaSemana()}
                                    </th>

                                    <th>
                                        1RA
                                    </th>

                                    <th>
                                        2DA
                                    </th>

                                </tr>

                            </thead>


                            <tbody className='text-center'>

                                {listaSucursal.map((item, index) => (

                                    <tr key={item.ID_SUCURSAL}>

                                        <td>
                                            {index + 1}
                                        </td>

                                        <td className='text-start'>
                                            {item.SUCURSAL}
                                        </td>

                                        <td className='text-start'>
                                            {item.DIRECCION || '-'}
                                        </td>

                                        <td>
                                            {item.SOLICITUD}
                                        </td>

                                        <td>
                                            {item.PRIMERA_VUELTA}
                                        </td>

                                        <td>
                                            {item.SEGUNDA_VUELTA}
                                        </td>

                                    </tr>

                                ))}

                            </tbody>


                            <tfoot className='text-center fw-bold'>

                                <tr>

                                    <td></td>

                                    <td colSpan="2">
                                        TOTAL
                                    </td>

                                    <td>
                                        {getTotal('SOLICITUD')}
                                    </td>

                                    <td>
                                        {getTotal('PRIMERA_VUELTA')}
                                    </td>

                                    <td>
                                        {getTotal('SEGUNDA_VUELTA')}
                                    </td>

                                </tr>

                            </tfoot>

                        </table>

                    </div>

                </Modal.Body>


                <Modal.Footer>

                    <button
                        className='btn btn-sm btn-secondary'
                        onClick={() =>
                            setShowModal(false)
                        }
                    >
                        <i className="fa-solid fa-xmark"></i>
                        {' '}Cerrar
                    </button>

                </Modal.Footer>

            </Modal>

        </>
    );
}

export default PedidoPapa;